<template>
  <div class="blex flex-no-wrap">

    <div>
      <div class="blex mx-10 mt-20">
        <img :src="value.img_a" class="market-pfp">
      </div>
      <div class="blex mx-10 mt-20">
        <img :src="value.img_b" class="market-pfp">
      </div>
      <div class="blex mx-10 mt-20">
        <img :src="value.img_c" class="market-pfp">
      </div>
      <div class="blex mx-10 mt-20">
        <img :src="value.img_d" class="market-pfp">
      </div>
    </div>

    <div class="mt-100">
      <div class="blex mx-10 mt-20">
        <img :src="value.img_e" class="market-pfp">
      </div>
      <div class="blex mx-10 mt-20">
        <img :src="value.img_f" class="market-pfp">
      </div>
      <div class="blex mx-10 mt-20">
        <img :src="value.img_g" class="market-pfp">
      </div>
      <div class="blex mx-10 mt-20">
        <img :src="value.img_h" class="market-pfp">
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'NftMarketCard',
  props: {
    value: {
      type: Object
    }
  },
  watch: {
    value: {
      deep: true,
      immediate: true,
      handler (val) {
        this.value = val
      }
    }
  }

}
</script>

<style scoped lang="scss">
div::v-deep {
}
</style>